<template>
  <div>
    <div class="head">
      <v-layout row>
        <v-flex xs10>
          <router-link to="/">
            <img
              src="@/assets/Pos/weserve-logo.png"
              alt="weserve-logo"
              width="200px"
              class="head-img"
            >
          </router-link>
          <!-- <span class="province">{{$t('front_web.town3')}}</span> -->
        </v-flex>
        <!-- <v-flex class="mt-2">
            <v-btn @click="toLandingPos()" flat>Point of sale</v-btn>
        </v-flex>
        <v-flex class="mt-2">  
            <v-btn @click="toLogin()" flat>pos log in </v-btn>
        </v-flex>-->
      </v-layout>
    </div>

    <div height="auto" id="section1">
      <div class="parallax">
        <!-- Big -->
        <div class="section1-layout hidden-sm-and-down">
          <v-layout row wrap align-center>
            <v-flex xs7>
              <h1 class="title1">
                {{$t('download_app.sec1_line1')}}
                <br>
                {{$t('download_app.sec1_line2')}}
              </h1>
              <h1 class="title2">{{$t('download_app.sec1_line3')}}</h1>
              <div class="title3">{{$t('download_app.sec1_line4')}}</div>
              <div class="title-download">{{$t('download_app.sec1_line5')}}</div>

              <div class="flex-container" style="display:flex;">
                <a
                  href="https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <div class="btn-apple elevation-3">
                    <v-layout row justify-center>
                      <v-flex xs4 class="text-xs-center">
                        <img src="@/assets/font/apple_logo.png" alt="apple" class="logo-apple">
                      </v-flex>
                      <v-flex xs8>
                        <span>Download on the</span>
                        <div class="font-apple">App Store</div>
                      </v-flex>
                    </v-layout>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=v4.weserve.application"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <div class="btn-google elevation-3">
                    <v-layout row justify-center>
                      <v-flex xs4 class="text-xs-center">
                        <img src="@/assets/font/google-play.png" alt="apple" class="logo-google">
                      </v-flex>
                      <v-flex xs8>
                        <span>Download on the</span>
                        <div class="font-google">Google Play</div>
                      </v-flex>
                    </v-layout>
                  </div>
                </a>
              </div>
            </v-flex>
            <v-flex xs5 class="pl-3 d-flex">
              <v-img
                :src="imgProvince($route.params.selectprovince)"
                alt="phone"
                width="400px"
                aspect-ratio="1"
                contain
              />
            </v-flex>
          </v-layout>
        </div>
        <!-- Small -->
        <div class="section1-small-layout hidden-md-and-up">
          <v-layout row wrap justify-center align-center>
            <v-flex xs12 style="position:absolute;top:70px;">
              <v-img
                :src="imgProvince($route.params.selectprovince)"
                alt="phone"
                width="300px"
                aspect-ratio="1"
                contain
              />
            </v-flex>
            <v-flex xs12 style="padding-top:180px;">
              <h1 class="title1">
                {{$t('download_app.sec1_line1')}}
                <br>
                {{$t('download_app.sec1_line2')}}
              </h1>
              <h1 class="title2">{{$t('download_app.sec1_line3')}}</h1>
              <div class="title3">{{$t('download_app.sec1_line4')}}</div>
              <div class="title-download">{{$t('download_app.sec1_line5')}}</div>

              <div class="flex-container-panda">
                <a
                  href="https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <div class="btn-apple elevation-3">
                    <v-layout row justify-center>
                      <v-flex xs4 class="text-xs-center">
                        <img src="@/assets/font/apple_logo.png" alt="apple" class="logo-apple">
                      </v-flex>
                      <v-flex xs8>
                        <span>Download on the</span>
                        <div class="font-apple">App Store</div>
                      </v-flex>
                    </v-layout>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=v4.weserve.application"
                  target="_blank"
                  style="text-decoration:none;"
                >
                  <div class="btn-google elevation-3">
                    <v-layout row justify-center>
                      <v-flex xs4 class="text-xs-center">
                        <img src="@/assets/font/google-play.png" alt="apple" class="logo-google">
                      </v-flex>
                      <v-flex xs8>
                        <span>Download on the</span>
                        <div class="font-google">Google Play</div>
                      </v-flex>
                    </v-layout>
                  </div>
                </a>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>

    <div height="auto" id="section2">
      <div class="section2-title">
        {{$t('download_app.sec2-title1')}}
        <br>
        <div class="big-font-container">
          <span class="big-font">{{$t('download_app.sec2-title2')}}</span>
          {{$t('download_app.sec2-title3')}}
        </div>
      </div>
      <v-container fluid grid-list-md class="my-2">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm2 class="text-xs-center">
            <img :src="icon1" alt="weserve" class="img-icon">
            <br>
            <div class="text-icon">
              <h3>{{$t('download_app.sec2-subtitle1')}}</h3>
              {{$t('download_app.sec2-content1')}}
            </div>
          </v-flex>
          <v-flex xs12 sm2 class="text-xs-center">
            <img :src="icon2" alt="weserve" class="img-icon">
            <br>
            <div class="text-icon">
              <h3>{{$t('download_app.sec2-subtitle2')}}</h3>
              {{$t('download_app.sec2-content2')}}
            </div>
          </v-flex>
          <v-flex xs12 sm2 class="text-xs-center">
            <img :src="icon3" alt="weserve" class="img-icon">
            <br>
            <div class="text-icon">
              <h3>{{$t('download_app.sec2-subtitle3')}}</h3>
              {{$t('download_app.sec2-content3')}}
            </div>
          </v-flex>
          <v-flex xs12 sm2 class="text-xs-center">
            <img :src="icon4" alt="weserve" class="img-icon">
            <br>
            <div class="text-icon">
              <h3>{{$t('download_app.sec2-subtitle4')}}</h3>
              {{$t('download_app.sec2-content4')}}
            </div>
          </v-flex>
          <v-flex xs12 sm2 class="text-xs-center">
            <img :src="icon5" alt="weserve" class="img-icon">
            <br>
            <div class="text-icon">
              <h3>{{$t('download_app.sec2-subtitle5')}}</h3>
              {{$t('download_app.sec2-content5')}}
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <img
        src="@/assets/font/landingPage/foods.png"
        alt="weserve"
        width="100%"
        class="hidden-xs-only"
      >
      <v-layout style="background-color:#ffdd00;" class="hidden-sm-and-up">
        <v-flex class="mt-2 mx-2">
          <img src="@/assets/font/landingPage/food1.jpg" alt="weserve" width="100%">
        </v-flex>
        <v-flex class="mt-2">
          <img src="@/assets/font/landingPage/food3.jpg" alt="weserve" width="100%">
        </v-flex>
        <v-flex class="mt-2 mx-2">
          <img src="@/assets/font/landingPage/food5.jpg" alt="weserve" width="100%">
        </v-flex>
      </v-layout>
      <!-- <v-carousel hide-controls height="auto">
        <v-carousel-item v-for="(mobileItems,i) in items" :key="i"><img :src="mobileItems.src" height="auto" width="100%"></v-carousel-item>
      </v-carousel>-->
    </div>

    <div height="auto" id="section3">
      <div class="section3-title">
        <span class="big-font">{{$t('download_app.sec3-title1')}}</span>
        {{$t('download_app.sec3-title2')}}
      </div>
      <img
        class="section3-img hidden-xs-only"
        :src="imgHow($i18n.locale)"
        alt="weserve"
        width="100%"
      >
      <div class="hidden-sm-and-up">
        <img class="section3-img" :src="imgFood($i18n.locale)" alt="weserve" width="100%">
        <img class="section3-img" :src="imgMess($i18n.locale)" alt="weserve" width="100%">
      </div>
    </div>

    <transition name="back-to-top-fade">
      <v-fab-transition>
        <v-btn light fab fixed bottom right @click="backToTop()" v-show="visible">
          <v-icon color="black">keyboard_arrow_up</v-icon>
        </v-btn>
      </v-fab-transition>
    </transition>

    <div class="footer">
      <a
        href="https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
        target="_blank"
        style="text-decoration:none;"
      >
        <img
          src="@/assets/font/landingPage/app_store.png"
          alt="weserve_app_store"
          class="pr-2 btn-footer"
        >
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=v4.weserve.application"
        target="_blank"
        style="text-decoration:none;"
      >
        <img
          src="@/assets/font/landingPage/google_play.png"
          alt="weserve_google_play"
          height="60px"
          class="pl-2 btn-footer"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_surat: require("@/assets/font/landingPage/surat_th.png"),
      img_krabi: require("@/assets/font/landingPage/krabi_th.png"),
      icon1: require("@/assets/font/landingPage/serve.png"),
      icon2: require("@/assets/font/landingPage/motorcycle.png"),
      icon3: require("@/assets/font/landingPage/paper_bag.png"),
      icon4: require("@/assets/font/landingPage/bill.png"),
      icon5: require("@/assets/font/landingPage/truck.png"),
      visibleoffset: 20,
      visible: false
    };
  },
  methods: {
    imgProvince(province) {
      if (province == "surat") {
        return this.imgLang_surat(this.$i18n.locale);
      } else if (province == "krabi") {
        return this.imgLang_krabi(this.$i18n.locale);
      }
    },
    imgLang_surat(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/surat_eng.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/surat_th.png");
      }
    },
    imgLang_krabi(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/krabi_eng.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/krabi_th.png");
      }
    },
    imgHow(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/how_it_work.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/how_it_work_th.png");
      }
    },
    imgFood(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/app_food_text.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/app_food_text_th.png");
      }
    },
    imgMess(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/app_messenger_text.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/app_messenger_text_th.png");
      }
    },
    // inSite() {
    //     this.$router.push({path : '/weserve_admin_login'})
    // },
    toLogin() {
      this.$router.push({ path: "/weserve_admin_login" });
    },
    toLandingPos() {
      this.$router.push({ path: "/landing_pos" });
    },
    /**
     @return {void}
        */
    catchScroll() {
      this.visible = window.pageYOffset > parseInt(this.visibleoffset);
    },
    /**
     @return {void}
        */
    backToTop() {
      window.smoothscroll();
    }
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  }
};
</script>

<style scoped>
.province {
  font-family: "GoldenPlains", "Kanit-Regular";
  font-size: 2rem;
  position: absolute;
  top: 14px;
  padding-left: 15px;
}
.flex-container {
  /* display: flex; */
  flex-wrap: wrap;
  justify-content: start;
  margin-top: 5px;
}
.img-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-apple {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-apple:hover {
  background-color: #333;
}
.btn-apple span {
  color: white;
}
.font-apple {
  color: white;
  font-size: 25px;
}
.logo-apple {
  height: 40px;
  margin-top: 8px;
}
.btn-google {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-google:hover {
  background-color: #333;
}
.btn-google span {
  color: white;
}
.font-google {
  color: white;
  font-size: 25px;
}
.logo-google {
  height: 35px;
  margin-top: 10px;
}
.section1-layout {
  /* background-color: #ffd600; */
  padding: 100px 80px 20px 80px;
  position: relative;
  /* margin-top: 80px; */
}
/* small */
.flex-container-panda {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
}
.section1-small-layout {
  padding: 170px 0 20px 0;
  position: relative;
  /* margin-top: 140px; */
}
.head {
  /* position: fixed; */
  position: absolute;
  z-index: 1;
  background-image: linear-gradient(
    to right,
    #ffdd00,
    #fcdb02cd,
    #fcdb02cd,
    #fcdb02cd,
    #ffffff00
  );
  width: 100%;
  /* margin-bottom: 30px; */
}
.head-img {
  cursor: pointer;
  margin: 10px 0 5px 25px;
}
.layout-container {
  padding-top: 130px;
}
.title1 {
  font-size: 40px;
  padding-left: 10px;
}
.title2 {
  font-size: 40px;
  background-image: linear-gradient(
    to right,
    rgba(87, 87, 87, 0.858),
    rgba(87, 87, 87, 0.858),
    rgba(87, 87, 87, 0.858),
    rgba(87, 87, 87, 0.858),
    rgba(255, 255, 255, 0)
  );
  color: #ffdd00;
  padding-left: 10px;
  margin-bottom: 10px;
}
.title3 {
  font-size: 20px;
  padding-left: 10px;
}
.title-download {
  font-size: 30px;
  font-weight: 900;
  padding: 30px 0 0 10px;
}
.section2-title {
  background-image: linear-gradient(
    to right,
    #ffdd00,
    #ffdd00,
    #ffdd00,
    #ffffffcd,
    #ffffffcd,
    #ffffffcd
  );
  /* padding-left:10px; */
  margin-bottom: 10px;
  font-size: 50px;
  font-weight: 600;
  padding: 10px 0 5px 50px;
  height: 150px;
  margin: 20px 0;
  position: relative;
}
.big-font-container {
  position: absolute;
  top: 55px;
}
.big-font {
  font-size: 60px;
  font-weight: 900;
}
.img-icon {
  height: 57px;
}

.section3-title {
  background-image: linear-gradient(
    to right,
    #ffdd00,
    #ffdd00,
    #ffffffcd,
    #ffffffcd,
    #ffffffcd
  );
  /* padding-left:10px; */
  margin-bottom: 10px;
  font-size: 50px;
  font-weight: 600;
  padding: 10px 0 5px 50px;
  /* height: 150px; */
  margin: 20px 0;
  /* position: relative; */
}
.section3-img {
  padding: 0 50px;
}
.parallax {
  background-image: url("../../assets/font/landingPage/bg1.png");
  min-height: 500px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.parallax-next {
  height: 1000px;
  background-color: red;
  font-size: 36px;
}
.footer {
  background-color: #ffdd00;
  padding: 10px 0 3px 0;
  display: flex;
  justify-content: center;
}
.btn-footer {
  height: 60px;
}
@media screen and (max-width: 1067px) {
  .title1 {
    font-size: 30px;
    padding-left: 20px;
    margin-top: 10px;
  }
  .title2 {
    font-size: 30px;
    background-image: linear-gradient(
      to right,
      rgba(87, 87, 87, 0.858),
      rgba(87, 87, 87, 0.858),
      rgba(87, 87, 87, 0.858),
      rgba(87, 87, 87, 0.858),
      rgba(255, 255, 255, 0)
    );
    color: #ffdd00;
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .title3 {
    font-size: 15px;
    padding-left: 20px;
  }
  .title-download {
    font-size: 20px;
    font-weight: 900;
    padding: 30px 0 0 20px;
  }
  .flex-container {
    margin-top: 0;
  }
  .font-apple {
    font-size: 20px;
  }
  .font-google {
    font-size: 20px;
  }
  .section2-title {
    font-size: 30px;
    background-image: linear-gradient(to right, #ffdd00, #ffdd00, #ffffffcd);
    margin-bottom: 10px;
    font-weight: 600;
    padding: 10px 0 5px 20px;
    height: 110px;
    margin: 20px 0;
    position: relative;
  }
  .big-font-container {
    position: absolute;
    top: 40px;
  }
  .big-font {
    font-size: 40px;
    font-weight: 900;
  }

  .section3-title {
    font-size: 30px;
    background-image: linear-gradient(to right, #ffdd00, #ffdd00, #ffffffcd);
    margin-bottom: 10px;
    font-weight: 600;
    padding: 10px 0 5px 20px;
    margin: 20px 0;
  }
  .btn-footer {
    height: 40px;
  }
}
@media screen and (max-width: 599px) {
  .text-icon {
    padding: 10px 50px;
  }
  .section3-img {
    padding: 0 30px 0 20px;
  }
  .img-icon {
    height: 50px;
  }
  .head-img {
    cursor: pointer;
    margin: 10px 0 5px 15px;
  }
}
</style>
